import * as THREE from 'three';

export class Minimap {
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private size: number = 200;
  private worldSize: number = 100; // 游戏世界大小
  private scale: number;

  constructor() {
    this.canvas = document.getElementById('minimap') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d')!;

    // 设置 canvas 大小
    this.canvas.width = this.size;
    this.canvas.height = this.size;

    this.scale = this.size / this.worldSize;
  }

  setWorldSize(worldSize: number): void {
    this.worldSize = worldSize;
    this.scale = this.size / this.worldSize;
  }

  clear(): void {
    this.ctx.clearRect(0, 0, this.size, this.size);

    // 绘制背景
    this.ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
    this.ctx.fillRect(0, 0, this.size, this.size);

    // 绘制边框
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 2;
    this.ctx.strokeRect(0, 0, this.size, this.size);

    // 绘制网格
    this.ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
    this.ctx.lineWidth = 1;
    const gridSize = 10;
    for (let i = 0; i <= this.worldSize / gridSize; i++) {
      const pos = i * gridSize * this.scale;
      // 垂直线
      this.ctx.beginPath();
      this.ctx.moveTo(pos, 0);
      this.ctx.lineTo(pos, this.size);
      this.ctx.stroke();
      // 水平线
      this.ctx.beginPath();
      this.ctx.moveTo(0, pos);
      this.ctx.lineTo(this.size, pos);
      this.ctx.stroke();
    }
  }

  worldToMap(worldX: number, worldZ: number): { x: number; y: number } {
    const x = (worldX + this.worldSize / 2) * this.scale;
    const y = (worldZ + this.worldSize / 2) * this.scale;
    return { x, y };
  }

  drawPlayer(position: THREE.Vector3, rotation: number): void {
    const pos = this.worldToMap(position.x, position.z);

    this.ctx.save();
    this.ctx.translate(pos.x, pos.y);
    this.ctx.rotate(rotation);

    // 绘制玩家坦克（三角形指向前方）
    this.ctx.fillStyle = '#00ff00';
    this.ctx.beginPath();
    this.ctx.moveTo(0, -8);
    this.ctx.lineTo(-5, 5);
    this.ctx.lineTo(5, 5);
    this.ctx.closePath();
    this.ctx.fill();

    // 绘制边框
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 1;
    this.ctx.stroke();

    this.ctx.restore();

    // 绘制玩家视野圆圈
    this.ctx.strokeStyle = 'rgba(0, 255, 0, 0.3)';
    this.ctx.lineWidth = 1;
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, 30 * this.scale, 0, Math.PI * 2);
    this.ctx.stroke();
  }

  drawEnemy(position: THREE.Vector3, isAlive: boolean): void {
    if (!isAlive) return;

    const pos = this.worldToMap(position.x, position.z);

    // 绘制敌人（红色方块）
    this.ctx.fillStyle = '#ff0000';
    this.ctx.fillRect(pos.x - 4, pos.y - 4, 8, 8);

    // 绘制边框
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 1;
    this.ctx.strokeRect(pos.x - 4, pos.y - 4, 8, 8);
  }

  drawObstacle(position: THREE.Vector3, size: { width: number; depth: number }): void {
    const pos = this.worldToMap(position.x, position.z);

    // 绘制障碍物（灰色矩形）
    this.ctx.fillStyle = 'rgba(139, 69, 19, 0.8)';
    const w = size.width * this.scale;
    const h = size.depth * this.scale;
    this.ctx.fillRect(pos.x - w / 2, pos.y - h / 2, w, h);

    this.ctx.strokeStyle = 'rgba(100, 100, 100, 0.5)';
    this.ctx.lineWidth = 1;
    this.ctx.strokeRect(pos.x - w / 2, pos.y - h / 2, w, h);
  }

  drawWall(position: THREE.Vector3, size: { width: number; depth: number }): void {
    const pos = this.worldToMap(position.x, position.z);

    // 绘制墙壁（深灰色）
    this.ctx.fillStyle = 'rgba(102, 102, 102, 0.9)';
    const w = size.width * this.scale;
    const h = size.depth * this.scale;
    this.ctx.fillRect(pos.x - w / 2, pos.y - h / 2, w, h);
  }

  drawPowerup(position: THREE.Vector3, type: string): void {
    const pos = this.worldToMap(position.x, position.z);

    // 根据类型选择颜色
    let color = '#ffff00';
    if (type === 'health') color = '#00ff00';
    else if (type === 'shield') color = '#00ffff';
    else if (type === 'ammo') color = '#ffa500';

    // 绘制道具（闪烁的圆形）
    const pulse = Math.sin(Date.now() / 200) * 0.3 + 0.7;
    this.ctx.fillStyle = color;
    this.ctx.globalAlpha = pulse;
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, 5, 0, Math.PI * 2);
    this.ctx.fill();
    this.ctx.globalAlpha = 1;

    // 绘制边框
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 1;
    this.ctx.stroke();
  }
}
